import React from "react";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import { DatePicker } from "antd";

class MissingChargesHeader extends React.Component {
    dateFormat = "YYYY-MM-DD";

    render() {
        return (
            <div className="row">
                <div className="col-7">
                    <div
                        className="form-group form-inline d-flex justify-content-end mb-2 w-100"
                        style={{ position: "absolute", top: "-60px" }}
                    >
                        <label className="mr-3">From Date</label>
                        <DatePicker
                            Format={this.dateFormat}
                            value={this.props.fromDate}
                            onChange={this.props.setFromDate}
                            placeholder=""
                        />
                        <Button
                            className="ml-2"
                            variant="success"
                            style={{ zIndex: 2 }}
                            onClick={this.props.handleLoad}
                        >
                            Load
                        </Button>
                    </div>
                </div>
                <div className="col-2 justify-content-end">
                    <label className="ml-5" style={{ position: "absolute", top: "-60px", paddingTop: "5px" }}>
                        {this.props.selectedText}
                    </label>
                </div>
                <div className="col-3 d-flex justify-content-end">
                    <div style={{ position: "absolute", top: "-60px" }}>
                        <Button
                            className="ml-2"
                            variant="primary"
                            style={{ zIndex: 2 }}
                            disabled={!this.props.enableCreate}
                            onClick={this.props.handleCreate}
                        >
                            Create Selected Charges
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}

MissingChargesHeader.propTypes = {
    fromDate: PropTypes.object,
    // selectedText: PropTypes.string.isRequired,
    enableCreate: PropTypes.bool.isRequired,

    setFromDate: PropTypes.func.isRequired,
    handleCreate: PropTypes.func.isRequired,

    handleLoad: PropTypes.func.isRequired,
};

export default MissingChargesHeader;
